import React, {memo, useState} from "react";
import {Head} from "../../components";
import Container from "@mui/material/Container";
import {Box} from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Api from "../../utils/api";
import {toast} from "react-toastify";
import {connect} from "react-redux";
import Button from "@mui/material/Button";
import {Paper} from "@mui/material";
import {useNavigate} from "react-router-dom";

const GalleryCreate = memo((props) => {

    const history = useNavigate();

    const { entities } = props;


    const initStat = {

    }

    const [form, setForm] = useState(initStat);
    const [loading, setLoading] = useState(false);


    const handleChangeElement = (event) => {
        let frm = {...form};
        frm[event.target.name] = event.target.value;
        setForm(frm);
    };


    const handleSubmit = (event) => {
        event.preventDefault();

        setLoading(true);

        new Api().post('/galleries', form).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    setForm(initStat);
                    toast.success(response.msg);
                    history('/gallery')
                } else {
                    toast.error(response.msg);
                }
            }
            setLoading(false);
        })

    }


    return(
        <Container>
            <Head data={{ 'link': '/gallery', 'title': 'ایجاد اسلایدر و گالری تصاویر'}} />
            <Box mt={5}>
                <Paper style={{ padding: 25}}>
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} >
                                <TextField
                                    label="عنوان"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='title'
                                    onChange={handleChangeElement}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    select
                                    label="وضعیت"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='status'
                                    onChange={handleChangeElement}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                >
                                    <MenuItem value={1}>فعال</MenuItem>
                                    <MenuItem value={0}>غیرفعال</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    select
                                    label="اسلایدر"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='is_slider'
                                    onChange={handleChangeElement}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                >
                                    <MenuItem value={1}>هست</MenuItem>
                                    <MenuItem value={0}>نیست</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField
                                    select
                                    label="نمایش"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='show_in'
                                    onChange={handleChangeElement}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                >
                                    {Object.keys(entities.show_in).map((item, index) => {
                                        return(
                                            <MenuItem value={item}>{entities.show_in[item]}</MenuItem>
                                        );
                                    })}

                                </TextField>
                            </Grid>
                        </Grid>
                        <Box mt={5}>
                            <Button disabled={loading} variant='contained' color='primary' type="submit">ایجاد گالری جدید</Button>
                        </Box>
                    </form>
                </Paper>
            </Box>
        </Container>
    );
})

const mapStateToProps = state => ({
    entities: state.galleryReducer
})

export default connect(mapStateToProps)(GalleryCreate);